import React from 'react'

import { ImageWrap } from '@hhgtech/hhg-components/components'

import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { assetImagePath } from 'interfaces/constants'

import {
  StyledImage,
  StyledCaption,
  StyledContainer,
  StyledItemImageContain,
} from './index.styled'

export type Props = {
  cardInfo: { image: string; url: string; title: string }
  isMobile?: boolean
  className?: string
}

const HealthToolCard = ({ cardInfo }: Props) => {
  const { locale } = useRouterExtend()

  return (
    <a
      className="no-replace-click"
      href={cardInfo.url}
      style={{
        textDecoration: 'none',
      }}
      data-event-category="Other Health Tools"
      data-event-action="Click"
      data-event-label={`https://${domainLocales[locale]}${cardInfo.url}`}
    >
      <StyledContainer>
        <StyledImage>
          <StyledItemImageContain>
            <ImageWrap
              src={cardInfo.image || `${assetImagePath}/avatar.jpg`}
              style={{ objectFit: 'contain' }}
              alt={cardInfo.title}
            />
          </StyledItemImageContain>
        </StyledImage>
        <StyledCaption>{cardInfo.title}</StyledCaption>
      </StyledContainer>
    </a>
  )
}

export { HealthToolCard }
